import { useParams } from 'react-router-dom';



export const tabs = [
  {
    id: 'awaitingApproval',
    label: "Return Requested",
    requiredPermissions: ['returnAuthorization_approval']
  },
  {
    id: 'awaitingShippingLabel',
    label: "Awaiting Shipping Label",
    requiredPermissions: [
      'returnAuthorization_viewShipment',
      'returnAuthorization_generateLabel',
      'returnAuthorization_downloadLabel'
    ]
  },
  {
    id: 'awaitingReceipt',
    label: "Awaiting Return",
    requiredPermissions: [
      'itemReceipt_create',
      'itemReceipt_view'
    ]
  },
  {
    id: 'awaitingAcceptance',
    label: "Accept/Deny Return",
    requiredPermissions: ['returnAuthorization_acceptance']
  },
  {
    id: 'refund',
    label: "Process Refund",
    requiredPermissions: [
      'refund_approval',
      'refund_view']
  }
] as const;

export type ITabId = typeof tabs[number]['id'];



export function useReturnAuthorizationActivityParams() {
  return useParams<{ tabId: ITabId; }>();
}
